import moment from 'moment';
import { associateFeedbackTableColumns } from '../../constants/tableColumns';
import useAssociateFeedbackActions from '../../hooks/APIHooks/appointments/useAssociateFeedbackActions';
import useCheckUserFeaturePermissions from '../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';

const ShowAllAssociateFeedbacks = () => {
  // integration of API hooks here
  const { getAssociateFeedbackListHandler } = useAssociateFeedbackActions(
    'associateFeedbackList'
  );

  // integration of custom hooks here
  const { featureBasedPermissions } =
    useCheckUserFeaturePermissions('associateFeedback');

  console.log(
    'ASSOCIATE FEEDBACK LIST: ',
    getAssociateFeedbackListHandler.data?.data,
    featureBasedPermissions
  );

  // rendering show all associate feedbacks component here
  return (
    <section>
      {getAssociateFeedbackListHandler.isLoading ||
      !featureBasedPermissions?.includes('READ') ? (
        <AcademiaLoading />
      ) : getAssociateFeedbackListHandler.isSuccess ? (
        <>
          <PageHeader headerText='All Associate Feedbacks' />

          <AcademiaTable
            data={getAssociateFeedbackListHandler.data.data.map((feedback) => ({
              ...feedback,
              created_at: moment(feedback.created_at).format('DD-MM-YYYY'),
            }))}
            columns={associateFeedbackTableColumns}
            notFoundMessage='No associate feedback found!'
          />
        </>
      ) : getAssociateFeedbackListHandler.isError ? (
        <AcademiaNotFound message='Failed to load client feedback data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllAssociateFeedbacks;
